import React from 'react';
import styled from '@emotion/styled';

import TimelineEntry from './TimelineEntry';

const Timeline = styled.ul`
  list-style-type: none;
  min-height: 26px;
  padding-left: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 88%;
`;

export default function Activity(props) {
  return (
    <Timeline>
      {props.timeline.map(entry => (
        <TimelineEntry entry={entry} key={entry.date + entry.status} />
      ))}
    </Timeline>
  );
}
